import {
  faCircleCheck,
  faCircleXmark,
  faClock,
  faClone,
} from '@fortawesome/free-regular-svg-icons';
import { faSpinner, IconDefinition, faBan, faCircleMinus } from '@fortawesome/free-solid-svg-icons';

export enum Status {
  ACTIVE = 'ACTIVE',
  ERROR = 'ERROR',
  PENDING = 'PENDING',
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED',
  FINISHED = 'FINISHED',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  DEACTIVATED = 'DEACTIVATED',
  PARTIAL = 'PARTIAL',
  BLOCKED = 'BLOCKED',
  SYNCERROR = 'SYNC_ERROR',
  DUPLICATE = 'DUPLICATE',
}

export type StatusLabelSize = 'small' | 'large';

export const STATUS_LABEL_TEXT: Record<Status, string> = {
  [Status.ACTIVE]: 'Active',
  [Status.ERROR]: 'Error',
  [Status.PENDING]: 'Pending',
  [Status.ENABLED]: 'Enabled',
  [Status.DISABLED]: 'Disabled',
  [Status.FINISHED]: 'Finished',
  [Status.FAILED]: 'Failed',
  [Status.IN_PROGRESS]: 'In progress',
  [Status.DEACTIVATED]: 'Deactivated',
  [Status.PARTIAL]: 'Partial',
  [Status.BLOCKED]: 'Blocked',
  [Status.SYNCERROR]: 'Sync Error',
  [Status.DUPLICATE]: 'Duplicated',
};

export const STATUS_LABEL_ICONS: Record<Status, IconDefinition> = {
  [Status.ACTIVE]: faCircleCheck,
  [Status.ERROR]: faCircleXmark,
  [Status.PENDING]: faClock,
  [Status.ENABLED]: faCircleCheck,
  [Status.DISABLED]: faBan,
  [Status.FINISHED]: faCircleCheck,
  [Status.FAILED]: faCircleXmark,
  [Status.IN_PROGRESS]: faSpinner,
  [Status.DEACTIVATED]: faBan,
  [Status.PARTIAL]: faCircleCheck,
  [Status.BLOCKED]: faCircleMinus,
  [Status.SYNCERROR]: faCircleXmark,
  [Status.DUPLICATE]: faClone,
};
